import { viewOrder } from "../order/actions";
import { ORDER_VIEW_FAIL, ORDER_VIEW_REQUEST } from "../order/actionType";
import axios from "./utils/axios";

const fetchOrderView = (order_id) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: ORDER_VIEW_REQUEST });
      const {
        login: { userInfo },
      } = getState();
      const config = {
        headers: {
          "Content-type": "application/json",
          Authorization: `Bearer ${userInfo.token}`,
        },
      };
      const { data } = await axios.get(
        `api/order/details/${order_id}/`,
        config
      );
      dispatch(viewOrder(data));
    } catch (error) {
      dispatch({
        type: ORDER_VIEW_FAIL,
        payload:
          error.response && error.response.data.details
            ? error.response.data.details
            : error.message,
      });
    }
  };
};
export default fetchOrderView;
